module.exports = __webpack_public_path__ + "static/media/insurance.788fd28a.svg";